import React, { FunctionComponent, Component, useEffect, useState, Fragment } from 'react';
import { Row, Col, Card, Modal, Form, Button  } from 'react-bootstrap';
import ButtonSubmit from '../basicComponents/buttonSubmit';
import ObexAlert from '../basicComponents/ObexAlerts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

type ModalProps = {
  showModal: boolean,
  onCloseModal: () => void,
  handleSubmit: (e) => void,
  loading: boolean,
  error: string,
  success: string,
  name_to_check: string,
  title_to_show: string
}

const ConfirmDeletetModal:FunctionComponent<ModalProps> = (props:ModalProps) => {
  
  const { showModal, onCloseModal, handleSubmit, loading, error, success, name_to_check, title_to_show } = props;
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [valor_a_comparar, setValorAComparar] = useState('');

  const CheckEntry = (value) =>{

    if (value==name_to_check) setSubmitDisabled(false)

  }
  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // Previene el envío del formulario
    }
  };
  return(
    <Modal dialogClassName="addons-dialog obex-dialog"
      show={showModal} 
      onHide={null}
      animation={false}
      scrollable
      container={document.getElementById('dashboardWrapper')}>
      <Modal.Header closeButton className="border-0 pb-0">
      
        <Modal.Title className="text-center mx-auto">
          <Row>
            <Col md="12" className="addons-title">
              <span>{title_to_show}</span>
            </Col>
          </Row>
        </Modal.Title>
        <button style={{ height:'15px', width:'10px', marginTop:'-5px', paddingLeft:'0px', zIndex:99999 }} onClick={onCloseModal} className="btn btn-close"></button>
      </Modal.Header>
      <div className="border-top border-black my-2 mx-3"></div>
      <Modal.Body className="pt-0">
        <Row>
          <Col md="8" className="text-center mx-auto">
           <Row >
            <div className='delLegend'>If there are any associated data, they will also be permanently deleted. To proceed, please type '{name_to_check}' to confirm.</div>
            </Row>
            </Col>
          </Row>

          <Col>
            <Form onKeyDown={handleKeyPress}>

            <Form.Row>
            <Col><span> 
              </span></Col>
            </Form.Row>
              <Form.Row >
              <Col md="6" className="mx-auto mt-3">
              <input type="text"  className="form-control" name="name" style={{ width: '100%' }} 
              onChange={(e) => {
                const { value } = e.target;
                CheckEntry(value)
              }}
              />
              </Col>
              </Form.Row>
              <Form.Row style={{textAlign:'center', marginTop:'1em'}}>
                <Col className='mx-auto'>

                  <Button
                    //handleSubmit={handleSubmit}
                    disabled={submitDisabled}
                   onClick={handleSubmit}
                   >Confirm Delete</Button>
                    
                </Col>
                
              </Form.Row>
              <Row>
                <Col>
                  <ObexAlert type='error' msg={error}/>
                </Col>
              </Row>
            </Form>
          </Col>

      </Modal.Body>
    </Modal>
  )
}

export default ConfirmDeletetModal;